export { StyleColorSocialLinkedin } from "./StyleColorSocialLinkedin";
